// src/components/IntercomBoot.jsx
import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth0 } from '@auth0/auth0-react';

const APP_ID = 'o3x36plv';

export default function IntercomBoot() {
  const { isAuthenticated, user, isLoading } = useAuth0();

  useEffect(() => {
    // Solo con sesión: todas las rutas del portal la exigen, así que sin ella no
    // hay pantalla donde mostrar el chat. Arrancarlo anónimo hacía aparecer el
    // globo antes del redirect al login.
    if (typeof window === 'undefined' || isLoading || !isAuthenticated || !user) return;

    Intercom({
      app_id: APP_ID,
      user_id: user?.sub,
      name:
        user?.name ||
        [user?.given_name, user?.family_name].filter(Boolean).join(' ') ||
        undefined,
      email: user?.email,
    });

    return () => {
      try { window.Intercom && window.Intercom('shutdown'); } catch {}
    };
  }, [isAuthenticated, isLoading, user]);

  return null;
}
